export const DEFAULT_CELL_SIZE = 24; // px
export const CELL_BORDER_COLOR = '#3F425D';
